const formMessageSelector = '[id$="-form-item-message"]';

const maxFramesToWaitForRender = 10;

export function scrollToFirstFormError() {
	let framesLeft = maxFramesToWaitForRender;

	const scrollWhenRendered = () => {
		const firstError = document.querySelector(formMessageSelector);

		if (!firstError) {
			framesLeft -= 1;

			if (framesLeft > 0) {
				requestAnimationFrame(scrollWhenRendered);
			}

			return;
		}

		firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
	};

	requestAnimationFrame(scrollWhenRendered);
}
